import { jsx as _jsx } from "react/jsx-runtime";
import { InsulinAdministrationModalForm, Modal } from "@madmedical/ui";
import { ApiFormWrapper } from "@madmedical/form";
import { useUpdateInsulinAdministrationMutation } from "../api";
const EditInsulinAdministrationModalForm = ({ open, onClose, administrationData, }) => {
    const [updateAdministration] = useUpdateInsulinAdministrationMutation();
    return (_jsx(Modal, Object.assign({ open: open, onClose: onClose, size: "xs" }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: Object.assign({}, administrationData), mutation: updateAdministration, resetOnSuccess: true }, { children: ({ submitForm, isSuccess }) => (_jsx(InsulinAdministrationModalForm, { onClose: onClose, onSubmitPress: submitForm, isSuccess: isSuccess, isEdit: true })) })) })));
};
export default EditInsulinAdministrationModalForm;
